import { toast } from "sonner"

interface ToastOptions {
  position?: "top-left" | "top-center" | "top-right" | "bottom-left" | "bottom-center" | "bottom-right"
  duration?: number
  description?: string
}

const defaultOptions: ToastOptions = {
  position: "top-center",
  duration: 3000,
}

export const Toast = {
  success: (message: string, options?: ToastOptions) => {
    const finalOptions = { ...defaultOptions, ...options }
    toast.success(message, {
      position: finalOptions.position,
      duration: finalOptions.duration,
      description: finalOptions.description,
      style: {
        color: "#22c55e", // 绿色
        fontWeight: "500",
        backgroundColor: "#f0fdf4", // 浅绿背景
        border: "1px solid #bbf7d0",
      }
    })
  },

  error: (message: string, options?: ToastOptions) => {
    const finalOptions = { ...defaultOptions, ...options }
    toast.error(message, {
      position: finalOptions.position,
      duration: finalOptions.duration,
      description: finalOptions.description,
      style: {
        color: "#ef4444", // 红色
        fontWeight: "500",
        backgroundColor: "#fef2f2", // 浅红背景
        border: "1px solid #fecaca",
      }
    })
  },

  warning: (message: string, options?: ToastOptions) => {
    const finalOptions = { ...defaultOptions, ...options }
    toast.warning(message, {
      position: finalOptions.position,
      duration: finalOptions.duration,
      description: finalOptions.description,
      style: {
        color: "#f59e0b", // 橙色
        fontWeight: "500",
        backgroundColor: "#fffbeb", // 浅橙背景
        border: "1px solid #fed7aa",
      }
    })
  },

  info: (message: string, options?: ToastOptions) => {
    const finalOptions = { ...defaultOptions, ...options }
    toast.info(message, {
      position: finalOptions.position,
      duration: finalOptions.duration,
      description: finalOptions.description,
      style: {
        color: "#3b82f6", // 蓝色
        fontWeight: "500",
        backgroundColor: "#eff6ff", // 浅蓝背景
        border: "1px solid #bfdbfe",
      }
    })
  },

  // 自定义 toast
  custom: (message: string, type: "success" | "error" | "warning" | "info", options?: ToastOptions) => {
    Toast[type](message, options)
  }
} 